import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]


export default /*@__PURE__*/_defineComponent({
  __name: 'BackgroundComponent',
  props: {
    backgroundColor: {},
    id: {},
    isPreview: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", {
    class: "inset-x-0 sticky p-4 lg:px-6 top-0 shadow-sm z-10",
    style: _normalizeStyle({ backgroundColor: _ctx.backgroundColor }),
    id: _ctx.id
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 12, _hoisted_1))
}
}

})